import { Link } from "@circleco/compass/components/Link";

import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";

import { usePricePreviewContext } from "../../PricePreviewProvider";
import { useModalPreview } from "./Modal";

interface ViewOrderDetailsLineProps {
  className?: string;
}

export const ViewOrderDetailsLine = ({
  className,
}: ViewOrderDetailsLineProps) => {
  const { previewMutation } = usePricePreviewContext();
  const modalPreview = useModalPreview();

  const showModal = () => {
    if (previewMutation?.data) {
      void modalPreview.show({ preview: previewMutation?.data });
    }
  };

  return (
    <Link
      asButton
      variant="custom"
      typography="label-xs"
      color="secondary"
      className={className}
      type="button"
      onClick={showModal}
      disabled={previewMutation.isPending}
    >
      <span
        className={classNames({
          "text-disabled": previewMutation.isPending,
          "hover:underline cursor-pointer": !previewMutation.isPending,
        })}
      >
        {t("view_order_details")}
      </span>
    </Link>
  );
};
